import React from "react";
import { func, bool, number } from "prop-types";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

const DeleteWatchListEntryModal = ({ isOpen, toggle, id, handleDelete }) => (
  <React.Fragment>
    <Modal isOpen={isOpen}>
      <ModalHeader>Delete Entry</ModalHeader>
      <ModalBody>Are you sure you want to delete this record?</ModalBody>
      <ModalFooter>
        <Button
          className="client-details-modal-button confirm-button"
          onClick={() => {
            handleDelete(id);
            toggle();
          }}
        >
          Delete
        </Button>
        <Button
          className="client-details-modal-button cancel-button"
          onClick={toggle}
        >
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  </React.Fragment>
);

DeleteWatchListEntryModal.propTypes = {
  isOpen: bool.isRequired,
  toggle: func.isRequired,
  id: number.isRequired,
  handleDelete: func.isRequired,
};

export default DeleteWatchListEntryModal;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/components/delete-watch-list-entry-modal/DeleteWatchListEntryModal.jsx